//Same in html
const attributeName = 'data-same-height-target';
const bpLimit = $('[data-same-height-bp]').attr('data-same-height-bp');
const $samHeightTargets    = $('[' + attributeName +']');



/**
 *
 * @param {Object} $jQuerySelector
 * @returns {Object}
 * { "data-targets value" :  $jQuerySelector of data-same-height-target value ... }
 */
const getjQweryElementsByDataTargets = ($jQuerySelector) => {
  let dataTargetsIndexes = [];
  let result = {}
  let uniqDataTargetsIndexes = [];
  $jQuerySelector.map(function(index, value) {
    dataTargetsIndexes.push($(this).attr(attributeName));
  });
  uniqDataTargetsIndexes = dataTargetsIndexes.filter(function(item, pos) {
    return dataTargetsIndexes.indexOf(item) == pos;
  });

  uniqDataTargetsIndexes.map((item) => {
    if ( $('['+ attributeName +'='+item+']').length > 1 ) {
      result[item] = $('['+ attributeName +'='+item+']');
    }
  })

  return result;
}

const samHeightTargetsList = getjQweryElementsByDataTargets($samHeightTargets);

/**
 *
 * @param {Object} samHeightTargetsList
 * @returns {Number}
 */
 const getHighestHeight = (samHeightTargetsList) => {
  let maxHeight = 0;
  for (let index = 0; index < samHeightTargetsList.length; index++) {
    const element = samHeightTargetsList[index];
    maxHeight = ($(element).height() > maxHeight) ? $(element).height() : maxHeight ;
  }
  return maxHeight;
}

/**
 *
 * @param {Object}  selector
 * @param {String} height
 */
 const setHighestHeight = (selector, height) => {
  $(selector).each((index, el) => {

    // if (height !== 'auto') {
    //   if ($(el).height() < height) {
    //     $(el).height(height);
    //   }
    // }else{
    //   $(el).height(height);
    // }
    $(el).height(height);

  })
}

/**
 *
 * @param {Object} samHeightTargetsList
 * { "data-same-height-target value" :  $jQuerySelector of data-same-height-target value ... }
 */
const recalcultateHeight = (samHeightTargetsList) => {
  let maxHeight;
  for (const [key, value] of Object.entries(samHeightTargetsList)) {
    //maxHeight = (screen.width  <= (bpLimit - 1)) ? 'auto' : getHighestHeight($(value));
    setHighestHeight($(value), 'auto');
  }
  for (const [key, value] of Object.entries(samHeightTargetsList)) {
    maxHeight = (window.innerWidth * window.devicePixelRatio  <= (bpLimit * window.devicePixelRatio - 1)) ? 'auto' : getHighestHeight($(value));
    setHighestHeight($(value), maxHeight);
  }
}


//onload
window.addEventListener('load', event => {
  recalcultateHeight(samHeightTargetsList)
});

//onresize
let ticking = false;
window.addEventListener('resize', event => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      recalcultateHeight(samHeightTargetsList)
      ticking = false;
    });
    ticking = true;
  }
})

$(function(){
  $('.experts-guide-you').on('click', function(ev) {
    if (!$.contains( $(ev.target).closest('.js-click-items').find('.overview_block_subcontent__phone-contact')[0], ev.target ) &&
    (!$(ev.target).hasClass('js-goToPage'))
    ) {
      window.location.href = $(ev.target).closest('.js-click-items').find('a.btn.secondary').attr('href');
    }
  })
})


